// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2np1D","content":"styles_content__3m86O","selectAll":"styles_selectAll__1TvEY"};